import { Chip, Icon, Tooltip } from '@mui/material';

export default function Enumeration(props) {
    const optionCount = Array.isArray(props.value) ? props.value.length : null;

    const buildTitle = () => {
        if (Array.isArray(props.value)) {
            const types = [];

            props.value.forEach(value => {
                if (props.filter.options.some(filter => 'options' in filter)) {
                    props.filter.options.forEach(option => {
                        option.options.forEach(subOption => {
                            if (subOption.value == value) types.push(subOption.label);
                        });
                    });
                } else {
                    props.filter.options.find(option => {
                        if (option.value == value) types.push(option.label);
                    });
                }
            });

            return types.join(', ');
        } else {
            let label;
            if (props.filter.options.some(filter => 'options' in filter)) {
                props.filter.options.forEach(option => {
                    option.options.find(subOption => {
                        if (subOption.value == props.value) {
                            label = subOption.label ?? '';
                        }
                    });
                });
            } else {
                label = props.filter.options.find(option => option.value == props.value)?.label ?? '';
            }
            return label;
        }
    };

    const chipData = {
        title: buildTitle(),
        label: `${props.filter.label}${optionCount ? ` (${optionCount})` : ''}`
    };

    const { title, label } = chipData;

    return (
        <Tooltip title={title} arrow>
            <Chip label={label} onClick={props.onClick} onDelete={() => props.handleDelete(props.filter.name)} deleteIcon={<Icon>close</Icon>} />
        </Tooltip>
    );
}
